module.exports = __webpack_public_path__ + "media/assets/images/events/agile_flow-8c7c622da3e00270fc64f37481e1f71e.png";